import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=076c46c8&scoped=true"
import script from "./MyCollection.vue?vue&type=script&lang=js"
export * from "./MyCollection.vue?vue&type=script&lang=js"
import style0 from "./MyCollection.vue?vue&type=style&index=0&id=076c46c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c46c8",
  null
  
)

export default component.exports